import React, { useState } from 'react';
import CampoBuscarClub from '../../UI/campos/CampoBuscarClub.js';
import CampoBuscarEquipo from '../../UI/campos/CampoBuscarEquipo.js';
import ComboSelector from '../../UI/campos/ComboSelector.js';
import CuadroDatos from '../../UI/CuadroDatos.js';
import SelectPais from '../../selectores/SelectPais.js';
import * as TipoRival from '../../constantes/TipoRival.js';
import * as Categorias from '../../constantes/Categorias.js';
import { PreFiltro } from '../../data/DataClubes.js';
import { PreFiltro as PreFiltroEquipo } from '../../data/DataEquipos.js';
import * as Funciones from '../../funciones/FuncionesHistoriales.js';
import styles from './SelectorRival.module.css';

const listaCategorias = [
  { id: null, descripcion: 'Todas' },
  { id: Categorias.MAYOR, descripcion: 'Mayor' },
];

const SelectorRival = (props) => {
  const club = props.club;
  const [tipoRival, setTipoRival] = useState(Funciones.EncontrarRival(TipoRival.CLUB));
  const [clubRival, setClubRival] = useState(null);
  const [categoriaClub, setCategoriaClub] = useState(listaCategorias[1]); // Mayor por defecto
  const [equipoRival, setEquipoRival] = useState(null);
  const [categoriaEquipo, setCategoriaEquipo] = useState(listaCategorias[1]); // Mayor por defecto
  const [paisSeleccion, setPaisSeleccion] = useState(null);
  const [categoriaSeleccion, setCategoriaSeleccion] = useState(listaCategorias[1]); // Mayor por defecto
  const [esMobile, setEsMobile] = useState(window.innerWidth < 600);

  React.useEffect(() => {
    const handleResize = () => {
      setEsMobile(window.innerWidth < 600);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onTipoRivalElegido = (tipoElegido) => {
    setTipoRival(tipoElegido);
    props.onRivalElegido(null, null);
  };

  // --- Club ---

  const buscarClub = (club, categoria) => {
    if (club) {
      const tipoElegido = Funciones.EncontrarRival(TipoRival.CLUB);
      props.onRivalElegido(tipoElegido, { ...club, categoria });
    }
  };

  const onClubElegido = (campo, clubElegido) => {
    const nuevoClub = clubElegido || null;
    setClubRival(nuevoClub);
    if (nuevoClub) {
      buscarClub(nuevoClub, categoriaClub);
    } else {
      props.onRivalElegido(null, null);
    }
  };

  const onCategoriaClubElegida = (categoriaElegida) => {
    setCategoriaClub(categoriaElegida);
    if (clubRival) {
      buscarClub(clubRival, categoriaElegida);
    }
  };

  const onBuscarClub = () => {
    if (clubRival) {
      buscarClub(clubRival, categoriaClub);
    }
  };

  // --- Equipo ---

  const buscarEquipo = (equipo, categoria) => {
    if (equipo) {
      const tipoElegido = Funciones.EncontrarRival(TipoRival.EQUIPO);
      props.onRivalElegido(tipoElegido, { ...equipo, categoria });
    }
  };

  const onEquipoElegido = (campo, equipoElegido) => {
    const nuevoEquipo = equipoElegido || null;
    setEquipoRival(nuevoEquipo);
    if (nuevoEquipo) {
      buscarEquipo(nuevoEquipo, categoriaEquipo);
    } else {
      props.onRivalElegido(null, null);
    }
  };

  const onCategoriaEquipoElegida = (categoriaElegida) => {
    setCategoriaEquipo(categoriaElegida);
    if (equipoRival) {
      buscarEquipo(equipoRival, categoriaElegida);
    }
  };

  const onBuscarEquipo = () => {
    if (equipoRival) {
      buscarEquipo(equipoRival, categoriaEquipo);
    }
  };

  // --- Selección ---

  const buscarSeleccion = (pais, categoria) => {
    if (pais) {
      const tipoElegido = Funciones.EncontrarRival(TipoRival.SELECCION);
      props.onRivalElegido(tipoElegido, {
        id: pais.id,
        pais,
        categoria,
      });
    }
  };

  const onPaisSeleccionElegido = (paisElegido) => {
    const nuevoPais = paisElegido || null;
    setPaisSeleccion(nuevoPais);
    if (nuevoPais) {
      buscarSeleccion(nuevoPais, categoriaSeleccion);
    } else {
      props.onRivalElegido(null, null);
    }
  };

  const onCategoriaSeleccionElegida = (categoriaElegida) => {
    setCategoriaSeleccion(categoriaElegida);
    if (paisSeleccion) {
      buscarSeleccion(paisSeleccion, categoriaElegida);
    }
  };

  const onBuscarSeleccion = () => {
    if (paisSeleccion) {
      buscarSeleccion(paisSeleccion, categoriaSeleccion);
    }
  };

  return (
    <CuadroDatos titulo="Rival" isCargando={false} errores={false}>
      <div
        className={`${styles.contenedor}`}
        style={{ padding: esMobile ? '0.5rem 0' : '0.5rem 0.5rem' }}
      >
        <span className={`${styles.titulo}`}>Tipo Rival</span>
        <ComboSelector
          lista={Funciones.TiposRival}
          valorActual={tipoRival}
          campoClave={'id'}
          campoDescripcion={'descripcion'}
          isCargando={false}
          onItemElegido={onTipoRivalElegido}
        />
        {tipoRival.id === TipoRival.CLUB && (
          <React.Fragment>
            <span className={`${styles.titulo}`}>Club Rival</span>
            <CampoBuscarClub
              prefiltro={PreFiltro.CLUB_RIVAL}
              objetoFiltro={club}
              nombre={TipoRival.CLUB}
              valor={clubRival}
              editar={true}
              width="100%"
              onClubElegido={onClubElegido}
            />
            <span className={`${styles.titulo}`}>Categoría</span>
            <ComboSelector
              lista={listaCategorias}
              valorActual={categoriaClub}
              campoClave={'id'}
              campoDescripcion={'descripcion'}
              isCargando={false}
              onItemElegido={onCategoriaClubElegida}
            />
            <button
              className={`${styles.botonBuscar}`}
              disabled={!clubRival}
              onClick={onBuscarClub}
            >
              Buscar
            </button>
          </React.Fragment>
        )}
        {tipoRival.id === TipoRival.EQUIPO && (
          <React.Fragment>
            <span className={`${styles.titulo}`}>Equipo Rival</span>
            <CampoBuscarEquipo
              prefiltro={PreFiltroEquipo.CLUB_RIVAL}
              objetoFiltro={club}
              nombre={TipoRival.EQUIPO}
              valor={equipoRival}
              editar={true}
              width="100%"
              onEquipoElegido={onEquipoElegido}
            />
            <span className={`${styles.titulo}`}>Categoría</span>
            <ComboSelector
              lista={listaCategorias}
              valorActual={categoriaEquipo}
              campoClave={'id'}
              campoDescripcion={'descripcion'}
              isCargando={false}
              onItemElegido={onCategoriaEquipoElegida}
            />
            <button
              className={`${styles.botonBuscar}`}
              disabled={!equipoRival}
              onClick={onBuscarEquipo}
            >
              Buscar
            </button>
          </React.Fragment>
        )}
        {tipoRival.id === TipoRival.SELECCION && (
          <React.Fragment>
            <span className={`${styles.titulo}`}>País</span>
            <SelectPais paisActual={paisSeleccion} onPaisElegido={onPaisSeleccionElegido} />
            <span className={`${styles.titulo}`}>Categoría</span>
            <ComboSelector
              lista={listaCategorias}
              valorActual={categoriaSeleccion}
              campoClave={'id'}
              campoDescripcion={'descripcion'}
              isCargando={false}
              onItemElegido={onCategoriaSeleccionElegida}
            />
            <button
              className={`${styles.botonBuscar}`}
              disabled={!paisSeleccion}
              onClick={onBuscarSeleccion}
            >
              Buscar
            </button>
          </React.Fragment>
        )}
      </div>
    </CuadroDatos>
  );
};

export default SelectorRival;
